
export default function Hero() {
  const handleScrollDown = () => {
    const nextSection = document.querySelector('#diensten');
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://static.readdy.ai/image/fc65efeb832ce485df7d40b8ca7edd24/696c69a217dcb82e340493ccb9930035.jpeg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight" spellCheck="false">
          <br /><br />Professionele Dakwerken<br />& Renovatie
        </h1>
        
        <p className="text-lg md:text-xl text-gray-100 max-w-3xl mx-auto mb-10 leading-relaxed">
          LBA Construct is uw specialist in dakwerken, zolder isolatie, gyproc werken en loodgieterij. Met vakmanschap en kwaliteit realiseren wij uw project in Merksem en omgeving.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a 
            href="#contact-form" 
            className="bg-red-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-red-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Gratis Offerte Aanvragen
          </a>
          <a 
            href="#diensten" 
            className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-white/20 transition-all border border-white/30 whitespace-nowrap cursor-pointer"
          >
            Onze Diensten
          </a>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
            <div className="text-4xl font-bold text-blue-400 mb-2">15</div>
            <div className="text-white text-sm">Jaar Ervaring</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
            <div className="text-4xl font-bold text-blue-400 mb-2">100+</div>
            <div className="text-white text-sm">Tevreden Klanten</div>
          </div>
        </div>
      </div>

      <div 
        onClick={handleScrollDown}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce cursor-pointer"
      >
        <i className="ri-arrow-down-line text-3xl text-white"></i>
      </div>
    </section>
  );
}
